import { z } from "zod";

const CharterType = z.enum(["bareboat", "skippered", "crewed"]);
const Brands = z.enum(["helm", "anchor"]);
const YachtApiStatus = z.enum(["synced", "delayed", "expired"]);
const BoatType = z.enum([
  "Sailing yacht",
  "Catamaran",
  "Do not display",
  "Gulet",
  "Jet ski",
  "Power catamaran",
  "R.I.B / Speed boat",
  "Other",
  "Motor yacht",
]);
const Api = z.enum(["BM", "CYA", "Helm", "NS", "Ankor", "Yachtfolio"]);

export const FiltersFormT = z.object({
  brand: z.array(Brands).or(z.tuple([])).optional(),
  charterType: z.array(CharterType).or(z.tuple([])).optional(),
  apiStatus: z.array(YachtApiStatus).or(z.tuple([])).optional(),
  provider: z.array(Api).or(z.tuple([])).optional(),
  country: z.string().optional(),
  yachtName: z.string().optional(),
  location: z.string().optional(),
  operator: z.array(z.string()).optional(),
  yachtId: z.string().optional(),
  boatType: z.array(BoatType).optional(),
  // TODO use below filters in Offers filters modal
  // price: z.object({
  //     min: z.number().min(1000).max(15000),
  //     max: z.number().min(1000).max(15000)
  // }),
  // cabins: z.object({
  //     min: z.number().min(1).max(30),
  //     max: z.number().min(1).max(30),
  // }),
  // bathrooms: z.object({
  //     min: z.number().min(1).max(30),
  //     max: z.number().min(1).max(10),
  // }),
  // year: z.object({
  //     min: z.number().min(1).max(2000),
  //     max: z.number().min(1).max(new Date().getFullYear()),
  // }),
});

export type FiltersFormT = z.infer<typeof FiltersFormT>;

export const emptyFiltersForm: FiltersFormT = {
  brand: [],
  charterType: [],
  apiStatus: [], //["synced"], TO BE UNCOMMENTED
  boatType: [],
  provider: [],
  country: "",
  yachtName: "",
  location: "",
  operator: [],
  yachtId: "",
  // price: {
  //     min: 1000,
  //     max: 15000,
  // },
  // cabins: {
  //     min: 1,
  //     max: 30,
  // },
  // bathrooms: {
  //     min: 1,
  //     max: 10,
  // },
  // year: {
  //     min: 1,
  //     max: new Date().getFullYear(),
  // },
};
